import React from "react"
import compact from "lodash/compact"

import CallToAction from "legacy/components/shared/CallToAction"
import { Element } from "legacy/components/shared/base"
import { mapButtonVariant } from "src/legacy/utils"
import { Maybe } from "types/Maybe"
import { OneColumnItemType } from "types/shared-components"

interface OwnProps {
  data: Maybe<Maybe<OneColumnItemType>[]>
}

export type ButtonsProps = OwnProps

const Buttons: React.FC<ButtonsProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  const nonEmptyButtons = data.filter(item => {
    return item?.button_text && item?.button_url?.url
  })

  if (nonEmptyButtons.length === 0) {
    return null
  }

  return (
    <Element mt={["40", "60"]} textAlign="center">
      {compact(nonEmptyButtons).map((item, index) => {
        const { button_color, button_text, button_type, button_url } = item
        const variant = mapButtonVariant(button_color)

        return (
          <CallToAction
            display="inline-block"
            fontSize={["16", "text.button"]}
            key={`button_${index}`}
            linkType={button_url.link_type}
            text={button_text}
            type={button_type}
            url={button_url.url}
            variant={variant}
          />
        )
      })}
    </Element>
  )
}

export default Buttons
